<script>
	import { quizLogoURL, startTime, language, prefix, i18n, mainStep, questions } from '../stores.js';

    $: activeStepTitle = $questions && $questions[$mainStep] ? $questions[$mainStep]['navigation_title'] : '';
</script>

<div>
    <ul class="{$prefix}-steps">
        {#each $questions as question, i}
            <li class="{$prefix}-step-container">
                {#if i > 0 }
                    <div class="{$prefix}-step-connector {$prefix}-step-connector--left"></div>
                {/if}
                <div class="{$prefix}-step {i <= $mainStep ? $prefix + '-step--active' : ''}">
                    <div class="{$prefix}-step__number">{i+1}</div> 
                    <div class="{$prefix}-step__name {i === $mainStep ? $prefix + '-primary' : ''} ">{question.navigation_title}</div>                
                </div>
                {#if i+1 < $questions.length }
                <div class="{$prefix}-step-connector {$prefix}-step-connector--right"></div>
                {/if}
            </li>
        {/each}
    </ul>
    <div class="{$prefix}-step-title-mobile"> { activeStepTitle } </div>
</div>


<style type="text/scss">
    @import './sass/vars';

    .#{$prefix}-steps { 
        list-style: none;
        padding: 2rem 0 0;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        @media only screen and (max-width: $breakpoint-medium) {
            margin-bottom: 1rem;
        }

    }

    .#{$prefix}-step-container { 
        position: relative;
    }
    .#{$prefix}-step-connector { 
        height: 2px;
        background: $background-gray;
        width: 50%;
        position: absolute;
        top: 20%;
        &--left {
            left: 0;
        }
        &--right {
            left: 50%;
        }
    }

    .#{$prefix}-step {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        min-width: 50px;
        &__number {
            width: 2rem;
            height: 2rem;
            text-align: center;
            line-height: 2rem;
            border-radius: 1rem;
            background: white;
            display: inline-block;
            color: $primary;
            position: relative;
            box-shadow: $drop-shadow-light;
            margin-bottom: 0.5rem;
            z-index: 1;

        }
        &__name {
            padding: 0.25rem 2rem;
            font-size: 0.75rem;
            @media only screen and (max-width: $breakpoint-medium) {
				display: none;
			}

            @media only screen and (max-width: $breakpoint-large) {
				padding: 0.25rem 1rem;
			}
        }
        &--active {
            .#{$prefix}-step__number {
                background: $primary;
                color: white;
                box-shadow: none;
            }
        }        

        &-title-mobile {
            width: 100%;
            text-align: center;
            font-size: 12px;
            @media only screen and (min-width: $breakpoint-medium) {
				display: none;
			}

        }
    }

</style>